import Image from "next/image";
const BlockGuide = () => {
  const blockContent = [
    {
      id: 1,
      // icon: "/img/featureIcons/1/1.svg",
      icon: "/img/featureIcons/3/1.svg",
      title: "Best Price Guarantee",
      text: `Find the best prices with us. If you find a lower rate, we’ll match it—guaranteed.`,
      delayAnim: "100",
    },
    {
      id: 2,
      icon: "/img/featureIcons/3/2.svg",
      title: "Easy & Quick Booking",
      text: `Book your ideal stay effortlessly and quickly. Your next adventure is just a few clicks away.`,
      delayAnim: "200",
    },
    {
      id: 3,
      icon: "/img/featureIcons/3/3.svg",
      title: "Customer Care 24/7",
      text: `We're here for you around the clock! Our support team is available 24/7 to assist with any questions or booking needs.`,
      delayAnim: "300",
    },
  ];
  return (
    <>
      {blockContent?.map((item) => (
        <div
          className="col-lg-3 col-sm-6"
          data-aos="fade"
          data-aos-delay={item?.delayAnim}
          key={item?.id}
        >
          <div className="featureIcon -type-1 ">
            <div className="d-flex justify-center">
              <Image  src={item?.icon} alt="image" width={70} height={70} className="js-lazy" loading="lazy"/>
            </div>
            <div className="text-center mt-30">
              <h4 className="text-18 fw-500">{item?.title}</h4>
              <p className="text-15 mt-10">{item?.text}</p>
            </div>
          </div>
        </div>
      ))}
    </>
  );
};

export default BlockGuide;
